export default "__VITE_ASSET__CbTMdM2Z__"